import React from 'react'

export default function ProgressBar ({ children }) {
  const childrenWithProps = React.Children.map(children, (child, index) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        hasLine: index < children.length - 1,
      })
    }
    return child
  })

  return (
    <div className="progress-bar">
      {childrenWithProps}
    </div>
  )
}